import { HttpClient } from '@angular/common/http';
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import Guid from 'devextreme/core/guid';
import ArrayStore from 'devextreme/data/array_store';
import CustomStore from 'devextreme/data/custom_store';
import DataSource, { DataSourceOptions } from 'devextreme/data/data_source';
import notify from 'devextreme/ui/notify';
import { groupBy, isEmpty, isNil, isObjectLike, omitBy, pickBy, set, uniqBy } from 'lodash-es';
import intersection from 'lodash-es/intersection';
import mapKeys from 'lodash-es/mapKeys';
import moment from 'moment';
import { BehaviorSubject, combineLatest, from, iif, of } from 'rxjs';
import {
  catchError,
  filter,
  finalize,
  map,
  mergeAll,
  mergeMap,
  startWith,
  switchMap,
  takeUntil,
  tap,
  zipAll,
} from 'rxjs/operators';
import { oc } from 'ts-optchain';
import {
  DxCellEvent,
  DxCellPreparedEvent,
  DxContextMenuPreparingEvent,
  DxSavedEvent,
  DxSavingEvent,
  DxToolbarPreparingEvent,
} from '../../../../../core/dx.types';
import { hAll, hasAmbTrips, hasBlsTrips, hTenant, isAlpha } from '../../../../../shared/classes/utils/utils';
import { ConfigService } from '../../../../../shared/modules/my-common/services/config.service';
import { DataSourceService } from '../../../../../shared/modules/my-common/services/datasource.service';
import { PusherService } from '../../../../../shared/modules/my-common/services/pusher.service';
import { StateStoreService } from '../../../../../shared/modules/my-common/services/state-store.service';
import { ABaseComponent } from '../../../../../shared/modules/ui/components/abstract/a-base.component';
import { DlgSelectSignatureComponent } from '../../../../../shared/modules/ui/components/dlg-select-signature/dlg-select-signature.component';
import { PushNotificationsService } from '../../../../../shared/modules/ui/services/push-notifications.service';
import { UiService } from '../../../../../shared/modules/ui/services/ui.service';
import {
  ConsumerView,
  ConsumerViewApi,
  Employee,
  EmployeeApi,
  Facility,
  FacilityApi,
  LoggerService,
  Signature,
  SignatureApi,
  SignatureConsUniqImgView,
  SignatureView,
  SignatureViewApi,
  TripManifest,
  TripManifestApi,
  TripManifestRec,
  TripRec,
  Vehicle,
  VehicleApi,
} from '../../../../../shared/sdk';
import { SVObject, TDsItem } from '../../../../operations/components/service-validation/types';
import { DlgUnlockServiceComponent } from '../../../../operations/dialogs/dlg-unlock-service/dlg-unlock-service.component';
import { ValidationService } from '../../../../operations/services/helper.service';
import { DIRECTION_MARKERS, SERVICE_TYPE } from '../../../../trip-manifest/classes/enums';
import { DlgSelectDriverComponent } from '../../../../trip-manifest/dialogs/dlg-select-driver/dlg-select-driver.component';
import { DlgSelectVehicleComponent } from '../../../../trip-manifest/dialogs/dlg-select-vehicle/dlg-select-vehicle.component';
import { DlgEditServiceStatusComponent } from '../../../dialogs/dlg-cancel-service/dlg-edit-service-status.component';
import { DlgChangeAdcWithClientComponent } from '../../../dialogs/dlg-change-adc-w-client/dlg-change-adc-w-client.component';
import { DlgChangeAdcComponent } from '../../../dialogs/dlg-change-adc/dlg-change-adc.component';
import { DlgEditOriginDestComponent } from '../../../dialogs/dlg-edit-origin-dest/dlg-edit-origin-dest.component';
import { DlgEditServiceTypeComponent } from '../../../dialogs/dlg-edit-service-type/dlg-edit-service-type.component';
import { DlgEditTimesComponent } from '../../../dialogs/dlg-edit-times/dlg-edit-times.component';
import { DlgEditUnitsComponent } from '../../../dialogs/dlg-edit-units/dlg-edit-units.component';

@Component({
  selector: 'app-billing-common-v2',
  templateUrl: './billing-common-v2.component.html',
  styleUrls: ['./billing-common-v2.component.scss'],
  providers: [ValidationService],
})
export class BillingCommonV2Component extends ABaseComponent implements OnInit {
  dso: any = new DataSource([]);
  facilityDso: DataSourceOptions = [];
  consumerDso: DataSourceOptions = [];
  employeeDso: DataSourceOptions = [];
  vehicleDso: DataSourceOptions = [];

  minPuDoDiff = 5;
  maxPuDoDiff = 65;
  maxPuLgtcPuDiff = 60;

  $filterEvent$: BehaviorSubject<any> = new BehaviorSubject<any>(false);

  $cmpAddresses$: BehaviorSubject<(number | { key: number; tripId: string })[]> = new BehaviorSubject([]);
  $chkTripIDs$: BehaviorSubject<{ key: number; cId: number; tripId: string; date: string }[]> = new BehaviorSubject([]);

  serviceTypes = [
    ...Object.values(SERVICE_TYPE),
    ...(hasAmbTrips() ? ['AMB_TRIP'] : []),
    ...(hasBlsTrips() ? ['BLS_TRIP'] : []),
  ];

  validationStates = [
    { v: 'PENDING', t: 'Not Validated' },
    { v: 'VALID', t: 'Valid' },
    { v: 'INVALID', t: 'Invalid' },
    { v: 'ISSUES', t: 'Issues' },

    { v: 'FULL_AUTO_VALIDATED', t: 'Full Auto Validated' },
    { v: 'PARTIAL_AUTO_VALIDATED', t: 'Partial Auto Validated' },
  ];

  ClaimStatuses = [
    'Billed',
    'Authorized',
    'Approved',
    'Processing',
    'Pending',
    'Transmitted',
    'Review',
    'Incomplete',
    'Paid',
    'Denied',
    'Cancelled',
  ];

  //region filter

  selectedFromValue?: Date = new Date();
  selectedToValue?: Date = new Date();

  facilityId?: number;
  driverId?: number;
  clientId?: number;

  validationState?: string;
  mci?: string;
  broker?: string;
  serviceType?: string;
  claimStatus?: string;
  mco?: string;
  hasUnusedTrips?: boolean;
  hasTripAssigned?: boolean;
  existTripIds?: boolean;
  hasClaim?: boolean;

  withDriverSigns = false;
  withEscortSigns = false;

  // billingStatus?: string;
  // claimState?: string;
  // clientName?: string;

  //endregion

  tripDsoMap: Map<number, any> = new Map();

  currentTooltipTemplate: 'trip';
  isTooltipVisible = false;
  tooltipTargetSelector: any = null;
  tooltipData: any;

  currentPopoverTemplate: 'mealImg' | 'addrMismatch';
  isPopoverVisible = false;
  popoverTargetSelector: any = null;
  popoverData: any;

  private vehicleDsMap: {
    [id: string]: {
      fullInstance?: any;
    };
  } = {};

  private driverDsMap: {
    [id: string]: {
      fullInstance?: any;
    };
  } = {};

  private dataCollection: string | undefined;

  //

  tripIdCellMouseOverMap = {};
  mealPhotoCellMouseOverMap = {};
  addrMismatchMouseOverMap = {};

  grid_stateStoring: any;

  @ViewChild(DxDataGridComponent, { static: false }) grid: DxDataGridComponent;
  // @ViewChild('from', {static: true}) fromDateBox: DxDateBoxComponent;
  // @ViewChild('to', {static: true}) toDateBox: DxDateBoxComponent;

  constructor(
    protected logger: LoggerService,
    private ui: UiService,
    public config: ConfigService,
    private dss: DataSourceService,
    private sss: StateStoreService,
    private pusher: PusherService,
    private notification: PushNotificationsService,
    @Inject(HttpClient) private http: HttpClient,
    private dialog: MatDialog,
    private sapi: SignatureApi,
    private svapi: SignatureViewApi,
    public service: ValidationService,
  ) {
    super(logger);

    this.grid_stateStoring = this.sss.buildOptions(
      '8d18dde1-6e95-4955-a42f-87e134e02bb1',
      1000,
      'local',
      this.sss.resetState,
    );

    this.dso = this.service.buildEmptyDataSource();
    this.facilityDso = this.service.buildFacilityDataSource();
    this.consumerDso = this.service.buildConsumerDataSource(this.facilityId);
    this.employeeDso = this.service.buildEmployeeDataSource(this.facilityId);
    this.vehicleDso = this.service.buildVehicleDataSource();
  }

  ngOnInit() {
    super.ngOnInit();

    {
      this.$filterEvent$
        .pipe(
          filter(arg => arg),
          tap(() => {
            this.grid.instance.beginCustomLoading('Filtering...');

            this.grid.instance.clearFilter();
            this.grid.instance.clearSelection();
            // await this.grid.instance.deselectAll();

            const curState = { ...this.grid.instance.state(), ...this.sss.resetState };
            // console.log('curState', curState);
            this.grid.instance.state(curState);
          }),
          switchMap(() =>
            this.buildDataSource().pipe(
              startWith(this.service.buildEmptyDataSource()),
              catchError(err => {
                notify(err.message, 'error', 10_000);
                return of(this.service.buildEmptyDataSource());
              }),
              tap(dso => {
                this.dso = dso;
              }),
              finalize(() => {
                this.grid.instance.endCustomLoading();
              }),
            ),
          ),
          takeUntil(this.$onDestroy$),
        )
        .subscribe();
    }

    {
      this.$cmpAddresses$
        .pipe(
          filter(keysOrObjs => keysOrObjs.length > 0),

          // normalize objects
          map(keysOrObjs =>
            keysOrObjs.map(keyOrObj => {
              const key = isObjectLike(keyOrObj) ? (keyOrObj as any).key : keyOrObj;
              const tripId = isObjectLike(keyOrObj) ? (keyOrObj as any).tripId : undefined;
              return { key, tripId };
            }),
          ),

          // map(objs => {
          //   const items = this.gridItemsFlat();
          //   const itemSet = new Set(items.map(doc => doc.id));
          //   return objs.filter(({ key }) => itemSet.has(key));
          // }),
          //
          // filter(objs => objs.length > 0),

          // reset values
          tap(() => this.grid.instance.beginUpdate()),
          mergeMap(objs =>
            this.storeUpdate$(
              objs.map(({ key, tripId }) => ({
                key,
                values: { __skipRepaint: true, _addresses: {}, __addrMismatch: '...' },
              })),
            ).pipe(
              catchError(err => of(console.error(err))),
              map(() => objs),
              finalize(() => this.grid.instance.endUpdate()),
            ),
          ),

          //

          mergeMap(objs =>
            from(objs).pipe(
              map(({ key, tripId }) =>
                this.sapi.getManifestAndTripAddresses(key, tripId, hAll).pipe(
                  catchError(err => of(console.error(err))),
                  map(res => {
                    const mismatch =
                      res &&
                      res.service &&
                      res.trip &&
                      (res.service.to || res.service.from) &&
                      (res.trip.to || res.trip.from)
                        ? {
                            to: res.service.to !== res.trip.to,
                            from: res.service.from !== res.trip.from,
                            both: res.service.to !== res.trip.to && res.service.from !== res.trip.from,
                            swapped: res.service.to === res.trip.from || res.service.from === res.trip.to,
                          }
                        : undefined;

                    return {
                      values: {
                        __skipRepaint: true,
                        _addresses: res || {},
                        __addrMismatch: mismatch
                          ? mismatch.both
                            ? mismatch.swapped
                              ? 'swapped'
                              : 'both'
                            : mismatch.to
                              ? 'dest'
                              : mismatch.from
                                ? 'origin'
                                : 'valid'
                          : '',
                      },
                      key,
                    };
                  }),
                  mergeMap(change => this.storeUpdate$([change]).pipe(catchError(err => of(console.error(err))))),
                ),
              ),
              mergeAll(),
            ),
          ),

          catchError(err => of(console.error(err))),
          takeUntil(this.$onDestroy$),
        )
        .subscribe();
    }

    {
      this.$chkTripIDs$
        .pipe(
          filter(objs => objs.length > 0),

          mergeMap(objects =>
            of(
              of(objects),

              of(this.gridItemsFlat()).pipe(
                map(items =>
                  items
                    .filter(itm => objects.map(o => o.cId).includes(itm.consumerId))
                    .map(o => ({
                      key: o.id,
                      date: o.vdate,
                      cId: o.consumerId,
                      tripId: oc(o)._trip._tripId(),
                    })),
                ),
              ),

              ...uniqBy(
                objects.filter(o => !isNil(o.tripId)),
                o => [o.cId, o.date].join(':'),
              ).map(({ cId, date }) =>
                this.sapi
                  .find<Signature>(
                    {
                      where: {
                        and: [
                          { vdate: date },
                          { consumerId: cId },
                          { validationState: { neq: 'INVALID' } },

                          { type: { nin: ['R', 'V', 'C'] } },
                          { or: [{ status: { nlike: 'X%' } }, { status: null }] },
                        ],
                      },
                      fields: { id: true, consumerId: true, vdate: true, vTripId: true },
                    },
                    hAll,
                  )
                  .pipe(
                    catchError(err => of([] as Signature[])),
                    map(docs =>
                      docs.map(doc => ({
                        key: doc.id,
                        cId: doc.consumerId,
                        date: doc.vdate,
                        tripId: doc.vTripId,
                      })),
                    ),
                  ),
              ),
            ).pipe(
              map(ob =>
                ob.pipe(
                  tap(() => this.grid.instance.beginUpdate()),
                  mergeMap(objs =>
                    this.storeUpdate$(
                      objs.map(({ key }) => ({
                        values: { __skipRepaint: true, __tripIdsMultiAssigned: '...' },
                        key,
                      })),
                    ).pipe(
                      map(() => objs),
                      finalize(() => this.grid.instance.endUpdate()),
                    ),
                  ),
                ),
              ),

              zipAll(),

              map(objs => objs.flat()),
              map(objs => {
                objs = uniqBy(objs, 'key');
                const byTripId = groupBy(
                  objs.filter(o => !isNil(o.tripId)),
                  o => o.tripId,
                );

                return objs.map(({ key, tripId }) => ({
                  key: key as any,
                  res: (byTripId[tripId] ? byTripId[tripId].length > 1 : false) as any,
                }));
              }),

              catchError(err => of([] as { key; res }[])),
              // tap(() => this.grid.instance.beginUpdate()),
              mergeMap(results =>
                this.storeUpdate$(
                  results.map(({ key, res }) => ({
                    values: { __skipRepaint: true, __tripIdsMultiAssigned: res },
                    key,
                  })),
                )
                  .pipe
                  // finalize(() => this.grid.instance.endUpdate())
                  (),
              ),
            ),
          ),
          //
          catchError(err => of(console.error(err))),
          takeUntil(this.$onDestroy$),
        )
        .subscribe();
    }
  }

  // region data sources

  private buildDataSource() {
    const self = this;

    return of(true).pipe(
      map(() => {
        const fromIncl = this.selectedFromValue;
        const toExcl = this.selectedToValue;

        const fromMoment = fromIncl && moment(fromIncl);
        const toMoment = toExcl && moment(toExcl).add(1, 'days');

        if (!fromMoment || !toMoment) {
          throw new Error('Period should be defined');
        }

        if (toMoment.diff(fromMoment, 'months') > 1) {
          throw new Error('Period should be less or equal to 1 month');
        }

        const strFrom = fromMoment && fromMoment.format('YYYY-MM-DD');
        const strTo = toMoment && toMoment.format('YYYY-MM-DD');

        return {
          fromIncl: strFrom,
          toExcl: strTo,

          mci: this.mci,
          mco: this.mco,
          broker: this.broker,

          validationState: this.validationState,
          serviceType: this.serviceType,
          hasTrip: this.hasTripAssigned,
          hasClaim: this.hasClaim,
          claimStatus: this.claimStatus,

          hasUnusedTrips: this.hasUnusedTrips,
          existTripIds: this.existTripIds,

          facilityIds: this.facilityId ? [this.facilityId] : [],
          driverIds: this.driverId ? [this.driverId] : [],
          clientIds: this.clientId ? [this.clientId] : [],

          withDriverSigns: this.withDriverSigns,
          withEscortSigns: this.withEscortSigns,
        };
      }),

      switchMap(_filter => this.pusher.rpc('GET_CLAIMS_V2', { ..._filter, useRunTask: true }, hAll)),

      map(coll => {
        this.dataCollection = coll;
        return this.dss.createMongoStore(coll, undefined, { key: 'id' });
      }),

      switchMap(async store => {
        const _self = this;

        return new ArrayStore({
          key: 'id',
          data: await store.load(),

          onPush(changes: Array<{ type; data; key; index }>) {
            // const rowIdxs = uniq(changes.filter(({ data }) => data.__skipRepaint !== true).map(({ key }) => key)).map(
            //   key => _self.grid.instance.getRowIndexByKey(key),
            // );
            // if (rowIdxs.length > 0) _self.grid.instance.repaintRows(rowIdxs);
            changes.forEach(({ data }) => (data.__skipRepaint = undefined));
          },

          onUpdating(key: any, values: SVObject) {
            values.__skipRepaint = undefined;
          },
        });
      }),

      map(store => {
        this.tripDsoMap.clear();

        return {
          store,
          reshapeOnPush: false, // !!! true value will cause infinite loop in grid refresh !!!
          map: (doc: SVObject) => {
            this.tripDsoMap.set(doc.id, doc._trips);

            doc.getBatchCount = function () {
              const _self = this;
              return oc(_self)._batchIds([]).length;
            }.bind(doc);

            doc.getBatchStatus = function () {
              const _self = this;
              return oc(_self)._currBatchStatus() || oc(_self)._lastBatchStatus();
            }.bind(doc);

            doc._locked = function () {
              const _self = this;
              return (
                oc(_self).meta.locked() ||
                oc(_self)._trips([]).length === 0 ||
                (oc(_self)._trip.__claim.__status() === 'Paid' &&
                  intersection(self.config.roles, ['SU', 'BILLER']).length === 0)
              );
            }.bind(doc);

            doc._trip = oc(doc)._trip(doc._possibleTrip);
            doc._trips.forEach(t => set(t, '__claim.__status', oc(t).__claim.__status(null)));

            //

            this.setIssueData(doc);

            return doc;
          },
          postProcess: (groupsOrItems: TDsItem<SVObject>[]) => {
            const data = this.gridItemsFlat(groupsOrItems);

            this.$cmpAddresses$.next(data.map(doc => ({ key: doc.id, tripId: oc(doc)._trip._tripId() })));
            this.$chkTripIDs$.next(
              data.map(doc => ({ key: doc.id, cId: doc.consumerId, date: doc.vdate, tripId: oc(doc)._trip._tripId() })),
            );

            return groupsOrItems;
          },
        } as DataSourceOptions;
      }),
    );
  }

  vehicleData(id) {
    const self = this;

    if (!id) {
      return of({});
    }

    if (!self.vehicleDsMap[id]) {
      self.vehicleDsMap[id] = {};
    }

    if (!self.vehicleDsMap[id].fullInstance) {
      const inst$ = this.dss.getApi<VehicleApi>(Vehicle).findById(id, {}, hAll);

      self.vehicleDsMap[id].fullInstance = inst$;
    }

    return self.vehicleDsMap[id].fullInstance;
  }

  driverData(id) {
    const self = this;

    if (!id) {
      return of({});
    }

    if (!self.driverDsMap[id]) {
      self.driverDsMap[id] = {};
    }

    if (!self.driverDsMap[id].fullInstance) {
      const inst$ = this.dss.getApi<EmployeeApi>(Employee).findById(
        id,
        {
          include: [{ person: { contact: ['addresses', 'phones', 'emails'] } }],
        },
        hAll,
      );

      self.driverDsMap[id].fullInstance = inst$;
    }

    return self.driverDsMap[id].fullInstance;
  }

  //endregion

  setIssueData(doc: SVObject) {
    const arrTime = oc(doc).arrivedTime() ? moment(oc(doc).arrivedTime(), 'HH:mm:ss') : null;
    const puTime = oc(doc).pickupTime() ? moment(oc(doc).pickupTime(), 'HH:mm:ss') : null;
    const doTime = oc(doc).dropoffTime() ? moment(oc(doc).dropoffTime(), 'HH:mm:ss') : null;
    const lgtcPu = oc(doc)._trip.pu_time() ? moment(oc(doc)._trip.pu_time(), 'HH:mm') : null;

    const tripLeg =
      oc(doc)._trip._broker(null) === 'MTM' ? (oc(doc)._trip._tripId('').endsWith('B') ? 'B' : 'A') : undefined;
    const tripTime = oc(doc)._trip._time(null) ? moment(oc(doc)._trip._time(null), 'HHmm') : null;

    const __issueData: SVObject['__issueData'] = [
      {
        field: ['consumer_mci', 'consumer_person_lastname', 'consumer_person_firstname'],
        issue: doc.consumer_status === 'INACTIVE' ? 'INACTIVE Client' : undefined,
      },
      {
        field: ['marker'],
        issue: doc.marker === DIRECTION_MARKERS.UNKNOWN ? 'Direction Marker is UNKNOWN' : undefined,
      },

      {
        field: ['__tripIdsMultiAssigned'],
        severity: 'critical',
        issue: doc.__tripIdsMultiAssigned === true ? 'Multi-assigned tripID' : undefined,
      },

      {
        field: ['__addrMismatch'],
        severity: 'warning',
        issue:
          doc.__addrMismatch !== 'valid'
            ? doc.__addrMismatch === 'swapped'
              ? 'Origin and Destination addresses swapped'
              : doc.__addrMismatch === 'both'
                ? 'Origin and Destination addresses mismatch'
                : doc.__addrMismatch === 'origin'
                  ? 'Origin addresses mismatch'
                  : doc.__addrMismatch === 'dest'
                    ? 'Destination addresses mismatch'
                    : undefined
            : undefined,
      },

      {
        field: ['_trip._tripId'],
        severity: 'warning',
        issue: !doc.vTripId
          ? 'tripID not assigned'
          : oc(doc)._trip._cancelled() === true || oc(doc)._trip['Trip Status']('').startsWith('X')
            ? 'trip is cancelled'
            : undefined,
      },

      {
        field: ['vServiceType'],
        severity: 'warning',
        issue:
          oc(doc).vServiceType() === 'BLS_TRIP' && oc(doc)._trip['Vehicle Type']('').toUpperCase() !== 'AMBULANCE'
            ? 'Invalid service type for non AMBULANCE'
            : oc(doc).vServiceType() !== 'BLS_TRIP' && oc(doc)._trip['Vehicle Type']('').toUpperCase() === 'AMBULANCE'
              ? 'Invalid service type for AMBULANCE'
              : undefined,
      },

      {
        field: ['pickupTime', 'dropoffTime'],
        issue:
          puTime && doTime && doTime.diff(puTime, 'minutes', true) < this.minPuDoDiff
            ? `DO and PU diff less than ${this.minPuDoDiff} min`
            : undefined,
      },
      {
        field: ['pickupTime', 'dropoffTime'],
        issue:
          puTime && doTime && doTime.diff(puTime, 'minutes', true) > this.maxPuDoDiff
            ? `DO and PU diff more than ${this.maxPuDoDiff} min`
            : undefined,
      },
      {
        field: ['pickupTime'],
        issue:
          puTime && lgtcPu && Math.abs(lgtcPu.diff(puTime, 'minutes', true)) > this.maxPuLgtcPuDiff
            ? `Broker PU (${oc(doc)._trip.pu_time()}) and Driver PU diff more than ${this.maxPuLgtcPuDiff} min`
            : undefined,
      },

      ...(isAlpha()
        ? [
            {
              field: ['dropoffTime'],
              severity: 'warning',
              issue:
                tripLeg === 'A' && doTime && doTime.diff(tripTime, 'minutes') < -30
                  ? `Broker DO [${tripTime.format('HH:mm')}] and Driver DO [${doTime.format('HH:mm')}] diff more than 30 min`
                  : undefined,
            },

            {
              field: ['dropoffTime'],
              severity: 'critical',
              issue:
                tripLeg === 'A' && doTime && doTime.diff(tripTime, 'minutes') > 5
                  ? `Broker DO [${tripTime.format('HH:mm')}] and Driver DO [${doTime.format('HH:mm')}] diff more than 5 min`
                  : undefined,
            },

            {
              field: ['pickupTime'],
              severity: 'warning',
              issue:
                tripLeg === 'B' && puTime && puTime.diff(tripTime, 'minutes') < -30
                  ? `Broker PU [${tripTime.format('HH:mm')}] and Driver PU [${puTime.format('HH:mm')}] diff more than 30 min`
                  : undefined,
            },

            {
              field: ['pickupTime'],
              severity: 'critical',
              issue:
                tripLeg === 'B' && puTime && puTime.diff(tripTime, 'minutes') > 5
                  ? `Broker PU [${tripTime.format('HH:mm')}] and Driver PU [${puTime.format('HH:mm')}] diff more than 5 min`
                  : undefined,
            },
          ]
        : []),
    ];

    return [...this.service.processIssueData(doc, __issueData)];
  }

  private get gridStore(): CustomStore | undefined {
    return oc(this.grid).instance() ? this.grid.instance.getDataSource().store() : undefined;
  }

  private get gridItems() {
    return oc(this.grid).instance() ? (this.grid.instance.getDataSource().items() as TDsItem<SVObject>[]) : undefined;
  }

  private gridItemsFlat(items?: TDsItem<SVObject>[]): SVObject[] {
    return oc(items)(this.gridItems)
      .map(itm =>
        itm.hasOwnProperty('key') && itm.hasOwnProperty('items')
          ? (this.gridItemsFlat((itm as any).items) as SVObject[])
          : (itm as SVObject),
      )
      .flat();
  }

  private storeUpdate$(entries: { key; values }[], withUpdate = true) {
    return this.service.storeUpdate$(
      entries,
      async (key, values) => {
        const doc = this.gridItemsFlat().find(itm => itm.id === key);
        const issueChanges = this.setIssueData({ ...doc, ...values });
        for (const { data } of issueChanges) {
          for (const k of Object.keys(data)) values[k] = data[k];
        }
      },
      withUpdate,
    );
  }

  filter() {
    this.$filterEvent$.next(true);
  }

  from_onValueChanged(e) {
    // console.log(e);
    this.selectedToValue = moment(e.value).toDate();
  }

  facility_onSelectionChanged(e) {
    // console.log(e.selectedItem);

    this.consumerDso = this.service.buildConsumerDataSource(this.facilityId);
    this.employeeDso = this.service.buildEmployeeDataSource(this.facilityId);
    this.vehicleDso = this.service.buildVehicleDataSource();
  }

  tripId_onSelectionChanged(cellInfo, e) {
    // this runs on init grid to
    // console.log(cellInfo, e.selectedItem);
    // console.log('tripId_onSelectionChanged', oc(cellInfo).data._trip._tripId(), oc(e.selectedItem)._tripId());
    // const newTrip = e.selectedItem;
    // this.$cmpAddresses$.next([{ key: cellInfo.key, tripId: oc(newTrip)._tripId() }]);
  }

  tripId_onValueChanged(cellInfo, e) {
    // this not runs on init grid
    // console.log('tripId_onValueChanged', oc(cellInfo).data._trip());

    const newTripId = e.value;
    const newTrip = cellInfo.data._trips.find(t => t._tripId === newTripId);

    // console.log('tripId_onValueChanged', newTrip);

    void this.storeUpdate$([{ key: cellInfo.key, values: { _trip: oc(newTrip)(null) } }])
      .pipe(
        tap(() => {
          this.$cmpAddresses$.next([{ key: cellInfo.key, tripId: oc(newTrip)._tripId() }]);
          this.$chkTripIDs$.next([
            {
              key: cellInfo.data.id,
              cId: cellInfo.data.consumerId,
              date: cellInfo.data.vdate,
              tripId: oc(newTrip)._tripId(),
            },
          ]);
        }),
      )
      .toPromise();

    // this.grid.instance.repaintRows([cellInfo.rowIndex]);
  }

  //////////////////////////////////////////////////////

  grid_onInitialized(e) {
    this.service.init({ grid: this.grid });
    this.grid.instance.clearSelection();
  }

  grid_onDataErrorOccurred(e) {
    console.log(e);
  }

  grid_onCellClick(e) {
    if (e.rowType === 'data' && e.column.caption === 'Trip ID') {
      e.event.stopImmediatePropagation();
    }
  }

  grid_onCellHoverChanged(e) {
    // if (e.rowType === 'data' && e.column.caption === 'Trip ID') {
    //   if (e.eventType === 'mouseover') {
    //     this.tripIdCellMouseOverMap[e.key] = true;
    //   } else if (e.eventType === 'mouseout') {
    //     this.tripIdCellMouseOverMap[e.key] = false;
    //   }
    // }
  }

  grid_onSelectionChanged(e) {
    // console.log('grid_onSelectionChanged');
    // this.$cmpAddresses$.next(e.selectedRowKeys);
    // this.$cmpAddresses$.next(
    //   (e.currentSelectedRowKeys as number[])
    //     .map(key => [key, (e.selectedRowsData as SVObject[]).find(data => data.id === key)])
    //     .map(([key, data]) => ({ key, tripId: oc(data)._trip._tripId() })),
    // );
  }

  grid_onToolbarPreparing(e: DxToolbarPreparingEvent) {
    e.toolbarOptions.items.unshift(
      // {
      //   // disabled: this.$showFromBroker$.value,
      //   name: 'changeAdc',
      //   locateInMenu: 'auto',
      //   widget: 'dxButton',
      //   location: 'after',
      //   sortIndex: 30,
      //   showText: 'always',
      //   options: {
      //     // icon: 'fas fa-folder-plus',
      //     text: 'Change ADC',
      //     hint: 'Change ADC for selected',
      //     onClick: this.grid_toolbar_changeAdc_onClick.bind(this),
      //   },
      // },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'assignTripIds',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          // icon: 'fas fa-folder-plus',
          text: 'Assign TripIDs to Trips',
          hint: 'Assign TripIDs to Trips',
          onClick: this.grid_toolbar_assignTripIds_onClick.bind(this),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'buildBatch',
        locateInMenu: 'auto',
        widget: 'dxDropDownButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-folder-plus',
          text: 'Build Paratransit Batch',
          hint: 'Build Paratransit Claims Batch',
          items: ['by Facility', 'All Together'],
          onItemClick: this.grid_toolbar_buildBatch_onClick.bind(this),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'buildClaims',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-folder-plus',
          text: 'Build Billed Claims',
          hint: 'Build Billed Claims (Create fake billed claims)',
          onClick: this.grid_toolbar_buildBilledClaims_onClick.bind(this),
        },
      },
      // {
      //   // disabled: this.$showFromBroker$.value,
      //   name: 'buildBatch',
      //   locateInMenu: 'auto',
      //   widget: 'dxButton',
      //   location: 'after',
      //   sortIndex: 30,
      //   showText: 'always',
      //   options: {
      //     icon: 'fas fa-folder-plus',
      //     text: 'Build Meals Batch',
      //     hint: 'Build Meals Claims Batch',
      //     onClick: this.grid_toolbar_buildMealsBatch_onClick.bind(this),
      //   }
      // },
      // {
      //   // disabled: this.$showFromBroker$.value,
      //   name: 'buildMealsReq',
      //   locateInMenu: 'auto',
      //   widget: 'dxButton',
      //   location: 'after',
      //   sortIndex: 30,
      //   showText: 'always',
      //   options: {
      //     icon: 'fas fa-build',
      //     text: 'Meals Trips Req',
      //     hint: 'Build Meals Trips Request Files',
      //     onClick: this.grid_toolbar_buildMealsReq_onClick.bind(this),
      //   }
      // },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'buildCtsOrderReq',
        locateInMenu: 'auto',
        widget: 'dxDropDownButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-build',
          text: 'Build CTS Report',
          hint: 'Build CTS Export Report',
          items: ['by Facility', 'All Together'],
          onItemClick: this.grid_toolbar_buildCtsReport_onClick.bind(this),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'buildMtmAuthsToAddReq',
        locateInMenu: 'auto',
        widget: 'dxDropDownButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-build',
          text: 'Build MTM Auths Request',
          hint: 'Build MTM Auths Request',
          items: ['by Facility', 'All Together'],
          onItemClick: this.grid_toolbar_buildMtmAuthsToAdd_onClick.bind(this),
        },
      },
      {
        // disabled: this.$showFromBroker$.value,
        name: 'buildSchoolReport',
        locateInMenu: 'auto',
        widget: 'dxButton',
        location: 'after',
        sortIndex: 30,
        showText: 'always',
        options: {
          icon: 'fas fa-file-signature',
          text: 'Build School Report',
          hint: 'Build School Report PDF',
          onClick: this.grid_toolbar_buildSchoolReport_onClick.bind(this),
        },
      },
      {
        name: 'refresh',
        locateInMenu: 'auto',
        location: 'after',
        sortIndex: 99,
        widget: 'dxButton',
        showText: 'inMenu',
        options: {
          icon: 'refresh',
          text: 'Refresh',
          hint: 'Refresh',
          onClick: () => e.component.refresh(),
        },
      },
    );
  }

  grid_onContextMenuPreparing(e: DxContextMenuPreparingEvent) {
    if (e.row && e.row.rowType === 'data' && !e.row.isEditing) {
      // this.logger.log(e);
      // const eId = get(e.row.data, HelperService.REC_FIELD_MAP.employeeId);
      // const cId = get(e.row.data, HelperService.REC_FIELD_MAP.consumerId);

      const doc: SVObject = e.row.data;
      const key = e.row.key;

      e.items = [
        {
          text: 'Change Arr/PU/DO Time',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditTimesComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  switchMap(v =>
                    iif(
                      () => !!v,
                      of(v).pipe(
                        map(res => ({
                          // scheduledTime: res.scheduledTime ? moment(res.scheduledTime).format('HH:mm:ss') : null,
                          arrivedTime: res.arrivedTime ? moment(res.arrivedTime).format('HH:mm:ss') : null,
                          pickupTime: res.pickupTime ? moment(res.pickupTime).format('HH:mm:ss') : null,
                          dropoffTime: res.dropoffTime ? moment(res.dropoffTime).format('HH:mm:ss') : null,
                        })),
                        // tap((res) => console.log(res)),
                        tap(() => this.ui.showLoading()),
                        //
                        switchMap(values => {
                          return this.sapi
                            .patchAttributes(doc.id, values, hAll)
                            .pipe(mergeMap(() => this.storeUpdate$([{ key, values }])));
                        }),
                        //
                        catchError(err => of(notify(err.message, 'error', 5000))),
                        tap(() => this.ui.hideLoading()),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Signature Image',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open<
                  any,
                  any,
                  {
                    data: SignatureConsUniqImgView;
                    toAllSignatures?: boolean;
                    toClient?: boolean;
                  }
                >(DlgSelectSignatureComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  switchMap(v =>
                    iif(
                      () => !!oc(v).data(),
                      of(v).pipe(
                        tap(() => this.ui.showLoading()),
                        switchMap(res => {
                          // if (this.data.signature) {
                          return this.sapi
                            .patchAttributes(doc.id, { imgFileId: res.data.imgFileId }, hAll)
                            .pipe(
                              mergeMap(() => this.storeUpdate$([{ key, values: { imgFileId: res.data.imgFileId } }])),
                            );
                          // } else if (this.data.consumer) {
                          //   return this.consApi.patchAttributes(
                          //     this.data.consumer.id,
                          //     {signImgFileId: res.data.imgFileId},
                          //     hAll,
                          //   );
                          // }
                        }),
                        //
                        catchError(err => of(notify(err.message, 'error', 5000))),
                        tap(() => this.ui.hideLoading()),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Vehicle',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgSelectVehicleComponent, {
                  width: '450px',
                  maxHeight: '650px',
                  hasBackdrop: true,
                  data: {
                    recIds: [doc.vehicleId],
                    filter: {},
                  },
                })
                .afterClosed()
                .pipe(
                  filter(keys => keys !== false && keys && keys.length === 1),
                  map(keys => keys[0]),
                  tap(() => this.ui.showLoading()),
                  switchMap(vId =>
                    this.sapi.patchAttributes(doc.id, { vehicleId: vId }, hAll).pipe(
                      mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                      mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                    ),
                  ),
                  //
                  catchError(err => of(notify(err.message, 'error', 5000))),
                  tap(() => this.ui.hideLoading()),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Driver',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgSelectDriverComponent, {
                  width: '450px',
                  maxHeight: '650px',
                  hasBackdrop: true,
                  data: {
                    recIds: [doc.employeeId],
                    filter: {
                      or: [
                        { tenantId: doc.tenantId },
                        { tenantIds: { $json_e_c: { $: JSON.stringify(doc.tenantId) } } },
                      ],
                    },
                    skipTenantCheck: true,
                  },
                })
                .afterClosed()
                .pipe(
                  filter(keys => keys !== false && keys && keys.length === 1),
                  map(keys => keys[0]),
                  tap(() => this.ui.showLoading()),
                  switchMap(eId =>
                    this.sapi.patchAttributes(doc.id, { employeeId: eId }, hAll).pipe(
                      mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                      mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                    ),
                  ),
                  //
                  catchError(err => of(notify(err.message, 'error', 5000))),
                  tap(() => this.ui.hideLoading()),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Service Type / Marker',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditServiceTypeComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  switchMap(v =>
                    iif(
                      () => !!v,
                      of(v).pipe(
                        tap(() => this.ui.showLoading()),
                        switchMap(({ serviceType, marker }) =>
                          this.sapi.updateServiceTypeAndMarker(doc.id, serviceType, marker, hAll).pipe(
                            // mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                            mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                          ),
                        ),
                        catchError(err => of(notify(err.message, 'error', 5000))),
                        tap(() => this.ui.hideLoading()),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change Origin / Destination',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else {
              let tripRec = oc(doc)._rec();

              void this.dialog
                .open(DlgEditOriginDestComponent, {
                  hasBackdrop: true,
                  width: '750px',
                  data: {
                    signature: doc,
                    origin: oc(tripRec).origin(),
                    destination: oc(tripRec).destination(),
                  },
                })
                .afterClosed()
                .pipe(
                  switchMap((v: { o; d }) =>
                    iif(
                      () => !!v,
                      of(v).pipe(
                        tap(() => this.ui.showLoading()),

                        switchMap(() =>
                          combineLatest([
                            this.dss.getApi<TripManifestApi>(TripManifest).find<TripManifest>(
                              {
                                where: { date: doc.vdate },
                                fields: ['id', 'tenantId', 'date'],
                                limit: 1,
                              },
                              hTenant(doc.tenantId),
                            ),

                            this.dss.getApi<TripManifestApi>(TripManifest).rec2TripRecKeysMap(),
                          ]),
                        ),

                        switchMap(([[m], keyMap]) => {
                          if (m) {
                            tripRec =
                              tripRec ||
                              ({
                                manifestRecId: new Guid().toString(),
                                date: m.date,
                                time: doc.arrivedTime,
                                tenantId: doc.tenantId,
                                vehicleId: doc.vehicleId,
                                consumerId: doc.consumerId,
                                employeeId: doc.employeeId,
                                oneTimeTrip: true,
                              } as TripRec);

                            tripRec = {
                              ...tripRec,
                              origin: v.o,
                              destination: v.d,
                              requestID: new Guid().toString(),
                            } as TripRec;

                            const rec: Partial<TripManifestRec> = {
                              ...omitBy(
                                Object.fromEntries(
                                  Object.entries(keyMap).map(([tripKey, recKey]) => [recKey, tripRec[tripKey]]),
                                ),
                                isNil,
                              ),
                            };

                            return this.dss
                              .getApi<TripManifestApi>(TripManifest)
                              .safeSaveRecord(m.id, rec, false, hAll)
                              .pipe(
                                switchMap((newRec: TripManifestRec) =>
                                  this.sapi.patchAttributes(doc.id, { manifestRecId: newRec.id }, hAll).pipe(
                                    mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                                    mergeMap(sv => this.storeUpdate$([{ key, values: { ...sv, _rec: tripRec } }])),
                                  ),
                                ),
                              );
                          } else {
                            return of(notify('No Trip Manifest found', 'warning', 5000));
                          }
                        }),
                        catchError(err => of(notify(err.message, 'error', 5000))),
                        tap(() => this.ui.hideLoading()),
                      ),
                    ),
                  ),
                )
                .toPromise();
            }
          },
        },
        {
          text: 'Change Meals Units',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditUnitsComponent, {
                  hasBackdrop: true,
                  data: { signature: doc },
                })
                .afterClosed()
                .pipe(
                  filter(v => !isEmpty(v)),
                  tap(() => this.ui.showLoading()),
                  switchMap(o => {
                    o = pickBy(
                      mapKeys(
                        o,
                        (v, k) =>
                          ({
                            W1759: 'HOT',
                            W1760: 'FROZEN',
                            W1761: 'SANDWICH',
                            W1762: 'EMERGENCY',
                            W1764: 'SPECIAL',
                          })[k] || k,
                      ),
                      (v, k) => v > 0,
                    );

                    return this.sapi.patchAttributes(doc.id, { meta: { mealDroppedCountList: o } }, hAll).pipe(
                      mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                      mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                    );
                  }),
                  //
                  catchError(err => of(notify(err.message, 'error', 5000))),
                  tap(() => this.ui.hideLoading()),
                )
                .toPromise();
          },
        },
        {
          text: 'Edit Service Record Status',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgEditServiceStatusComponent, {
                  width: '400px',
                  // maxHeight: '650px',
                  hasBackdrop: true,
                  data: doc,
                })
                .afterClosed()
                .pipe(
                  switchMap(v =>
                    iif(
                      () => !!v,
                      of(v).pipe(
                        tap(() => this.ui.showLoading()),
                        switchMap(({ status, note }) => {
                          return this.sapi
                            .patchAttributes(
                              doc.id,
                              {
                                status,
                                note,
                              },
                              hAll,
                            )
                            .pipe(
                              mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                              mergeMap(sv =>
                                this.storeUpdate$([
                                  {
                                    key,
                                    values: {
                                      ...sv,
                                      _cancelled: !!(['R', 'V', 'C'].includes(sv.type) || sv.status.startsWith('X')),
                                    },
                                  },
                                ]),
                              ),
                            );
                        }),

                        catchError(err => of(notify(err.message, 'error', 5000))),
                        tap(() => this.ui.hideLoading()),
                      ),
                    ),
                  ),
                )
                .toPromise();
          },
        },
        {
          text: 'Change ADC',
          onItemClick: () => {
            if (oc(doc).meta.locked()) {
              notify('Service is locked', 'warning', 5000);
            } else
              void this.dialog
                .open(DlgChangeAdcWithClientComponent, {
                  width: '750px',
                  maxHeight: '650px',
                  hasBackdrop: true,
                  data: { sv: doc },
                })
                .afterClosed()
                .pipe(
                  filter((pair: [Facility, ConsumerView]) => pair && pair.length && !!pair[0] && !!pair[1]),
                  tap(() => this.ui.showLoading()),
                  switchMap(([f, cv]) =>
                    this.sapi.patchAttributes(doc.id, { tenantId: f.id, consumerId: cv.id }, hAll).pipe(
                      mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                      mergeMap(sv =>
                        this.storeUpdate$([
                          {
                            key,
                            values: {
                              ...sv,

                              _client: {
                                mco: cv.activeMco,
                                broker: cv.activeBroker,
                              },

                              _tenant: {
                                name: f.shortname,
                              },
                            },
                          },
                        ]),
                      ),
                    ),
                  ),
                  tap(() => this.$cmpAddresses$.next([doc.id])),
                  catchError(err => of(notify(err.message, 'error', 5000))),
                  tap(() => this.ui.hideLoading()),
                )
                .toPromise();
          },
        },
        {
          text: 'Unlock',
          onItemClick: () => {
            void this.dialog
              .open(DlgUnlockServiceComponent, {
                width: '450px',
                hasBackdrop: true,
                data: { signature: doc },
              })
              .afterClosed()
              .pipe(
                switchMap(v =>
                  iif(
                    () => !!v && !isEmpty(v),
                    of(v).pipe(
                      tap(() => this.ui.showLoading()),

                      switchMap(note =>
                        this.sapi.unlock(doc.id, note, hAll).pipe(
                          mergeMap(() => this.svapi.findById<SignatureView>(doc.id, {}, hAll)),
                          mergeMap(sv => this.storeUpdate$([{ key, values: sv }])),
                          // tap(() => this.grid.instance.repaintRows([e.rowIndex])),
                        ),
                      ),
                      //
                      catchError(err => of(notify(err.message, 'error', 5000))),
                      tap(() => this.ui.hideLoading()),
                    ),
                  ),
                ),
              )
              .toPromise();
          },
        },
      ];
    }
  }

  grid_onCellPrepared(e: DxCellPreparedEvent<SVObject>) {
    if (e.rowType === 'data') {
      const _cleanUpClass = _e => {
        const cellClasses = [
          'cell-red',
          'cell-green',
          'cell-blue',
          'cell-yellow',
          'cell-orange',
          'cell-violet',
          'cell-trip-warning',
          'cell-trip-danger',
        ];

        _e.cellElement.classList.remove(...cellClasses);
        _e.cellElement.title = '';
      };
      _cleanUpClass(e);

      {
        this.service.processIssuesForCell(e);
      }

      {
        const _lockedFn = () => {
          e.cellElement.classList.remove('cell-locked');
          if (oc(e).data.meta.locked()) {
            e.cellElement.classList.add('cell-locked');
          }
        };

        _lockedFn();
        e.watch(() => e.data.meta.locked, _lockedFn);
      }

      // switch (e.column.dataField) {
      // case '__addrMismatch': {
      //   if (oc(e).data.__addrMismatch('') === '...') {
      //     e.cellElement.classList.add('cell-blue');
      //   } else if (oc(e).data.__addrMismatch('') === 'valid') {
      //     e.cellElement.classList.add('cell-green');
      //   } else if (!isEmpty(oc(e).data.__addrMismatch(''))) {
      //     e.cellElement.classList.add('cell-trip-warning');
      //   }
      //   break;
      // }

      // case '__tripIdsMultiAssigned': {
      //   if (oc(e).data.__tripIdsMultiAssigned('') === '...') {
      //     e.cellElement.classList.add('cell-blue');
      //   } else if (oc(e).data.__tripIdsMultiAssigned() === true) {
      //     e.cellElement.classList.add('cell-trip-danger');
      //   }
      //   break;
      // }

      // case '_trip._tripId': {
      //   if (!oc(e).data.vTripId()) {
      //     e.cellElement.classList.add('cell-trip-warning');
      //   }
      //
      //   if (oc(e).data._trip._cancelled() === true || oc(e).data._trip['Trip Status']('').startsWith('X')) {
      //     e.cellElement.classList.add('cell-trip-warning');
      //   }
      //
      //   if (
      //     (oc(e).data.vServiceType() === 'BLS_TRIP' &&
      //       oc(e).data._trip['Vehicle Type']('').toUpperCase() !== 'AMBULANCE') ||
      //     (oc(e).data.vServiceType() !== 'BLS_TRIP' &&
      //       oc(e).data._trip['Vehicle Type']('').toUpperCase() === 'AMBULANCE')
      //   ) {
      //     e.cellElement.classList.add('cell-trip-warning');
      //   }
      //
      //   break;
      // }
      // }
    }
  }

  grid_onSaving(e: DxSavingEvent) {}

  grid_onSaved(e: DxSavedEvent) {}

  ////////////////////////////////////////////////

  grid_toolbar_assignTripIds_onClick() {
    const selectedPairs: any[] = this.grid.instance.getSelectedRowsData().map(s => [s.id, oc(s)._trip._tripId()]);

    if (selectedPairs.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    void of(...selectedPairs)
      .pipe(
        tap(() => this.ui.showLoading()),
        //
        switchMap(async ([sId, tripId]) => {
          // console.log('assign', sId, tripId);
          const s = await this.sapi.findById<Signature>(sId, {}, hAll).toPromise();
          await this.sapi.patchAttributes(sId, { meta: { ...s.meta, tripId: oc(tripId)(null) } }, hAll).toPromise();
          const sv = await this.svapi.findById<SignatureView>(sId, {}, hAll).toPromise();
          await this.storeUpdate$([{ key: sv.id, values: sv }]).toPromise();
        }),
        //
        catchError(err => of(notify(err.message, 'error', 10_000))),
        tap(() => this.ui.hideLoading()),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  grid_toolbar_changeAdc_onClick() {
    if (this.grid.instance.getSelectedRowKeys().length === 0) return;

    const fapi = this.dss.getApi<FacilityApi>(Facility);
    const cvapi = this.dss.getApi<ConsumerViewApi>(ConsumerView);

    void this.dialog
      .open(DlgChangeAdcComponent, {
        width: '750px',
        maxHeight: '650px',
        hasBackdrop: true,
        data: {
          keys: this.grid.instance.getSelectedRowsData().map((sv: SVObject) => sv.tenantId),
        },
      })
      .afterClosed()
      .pipe(
        filter((f: Facility) => !!f),
        tap(() => this.ui.showLoading()),
        switchMap(async f => {
          const pairs = await Promise.all(
            this.grid.instance.getSelectedRowsData().map(async (row: SVObject) => {
              return cvapi
                .find<ConsumerView>(
                  {
                    where: {
                      and: [
                        { tenantId: f.id },
                        {
                          or: [
                            {
                              and: [{ mci: { neq: null } }, { mci: oc(row).consumer_mci() }],
                            },
                            {
                              and: [
                                { person_firstname: oc(row).consumer_person_firstname() },
                                { person_lastname: oc(row).consumer_person_lastname() },
                                { person_dob: oc(row).consumer_person_dob() },
                              ],
                            },
                          ],
                        },
                      ],
                    },
                  },
                  hAll,
                )
                .pipe(
                  switchMap(([cv]) =>
                    iif(
                      () => !!cv,
                      of(cv).pipe(
                        switchMap(() => this.sapi.patchAttributes(row.id, { tenantId: f.id, consumerId: cv.id }, hAll)),
                        mergeMap(() => this.svapi.findById<SignatureView>(row.id, {}, hAll)),
                        mergeMap(sv =>
                          this.storeUpdate$([
                            {
                              key: row.id,
                              values: {
                                ...sv,

                                _client: {
                                  mco: cv.activeMco,
                                  broker: cv.activeBroker,
                                },

                                _tenant: {
                                  name: f.shortname,
                                },
                              },
                            },
                          ]),
                        ),
                        tap(() => this.$cmpAddresses$.next([row.id])),
                        map(() => [row.id, true]),
                      ),
                      of([row.id, false]),
                    ),
                  ),
                )
                .toPromise();
            }),
          );

          // this.grid.instance.refresh();

          this.grid.instance.selectRows(
            pairs.filter(([, replaced]) => !replaced).map(([key]) => key),
            false,
          );

          alert(
            'Selected signatures cannot be changed automatically.' +
              ' Corresponding client not found in target facility.',
          );
        }),
        //
        catchError(err => of(notify(err.message, 'error', 5000))),
        tap(() => this.ui.hideLoading()),
      )
      .toPromise();
  }

  grid_toolbar_buildBilledClaims_onClick() {
    // const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();
    // const selectedTripIds: any[] = this.grid.instance.getSelectedRowsData().map((d) => oc(d)._trip._tripId());

    const sItems = this.grid.instance.getSelectedRowsData();

    // console.log(this.grid.instance.getDataSource().sort());

    if (sItems.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    if (sItems.some(s => s.vServiceType !== SERVICE_TYPE.MEALS && isEmpty(s.vTripId))) {
      notify('There are some services with no TripID assigned', 'error', 5000);
      return;
    }

    const selectedPairs = sItems.map(s => [s.id, s.vTripId] as [number, string]);

    notify('Billed Claims Build Requested');

    const notificationOptions: NotificationOptions = {
      body: 'Billed Claims Generation Done!',
      requireInteraction: true,
    };

    this.pusher
      .rpc('BUILD_BILLED_CLAIMS', {
        pairs: selectedPairs,
        useRunTask: true,
      })
      .pipe(
        switchMap(url => this.http.get(url, { responseType: 'json', withCredentials: false })),
        switchMap((claims: any[]) =>
          Promise.all(
            claims.map(cl => this.storeUpdate$([{ key: cl._sId, values: { '_trip.__claim': cl } }]).toPromise()),
          ),
        ),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe(console.log);
  }

  grid_toolbar_buildBatch_onClick(e: { itemData }) {
    // const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();
    // const selectedTripIds: any[] = this.grid.instance.getSelectedRowsData().map((d) => oc(d)._trip._tripId());
    const selectedPairs: any[] = this.grid.instance.getSelectedRowsData().map(s => [s.id, oc(s)._trip._tripId()]);

    // console.log(this.grid.instance.getDataSource().sort());

    if (selectedPairs.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    if (selectedPairs.some(([sId, tId]) => !tId)) {
      notify('There are some services with no TripID assigned', 'error', 5000);
      return;
    }

    notify('Batch Requested');

    const notificationOptions: NotificationOptions = {
      body: 'Batch Generation Done!',
      requireInteraction: true,
    };

    void Promise.all(
      selectedPairs.map(([sId]) =>
        this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'PENDING' } }]).toPromise(),
      ),
    );

    this.pusher
      .rpc('BUILD_CLAIMS_BATCH', {
        // signatureIds: selectedIds,
        // tripIds: selectedTripIds,
        pairs: selectedPairs,
        byFacility: e.itemData === 'by Facility',
        useRunTask: true,
      })
      .pipe(
        switchMap(() =>
          Promise.all(
            selectedPairs.map(([sId]) =>
              this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'IN BATCH' } }]).toPromise(),
            ),
          ),
        ),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();

    // this.ui.openEditDialog({
    //   modelId: null,
    //   ModelClass: Consumer,
    //   FormComponentClass: ConsumerFormComponent,
    // });
  }

  grid_toolbar_buildMealsBatch_onClick() {
    // const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();
    // const selectedTripIds: any[] = this.grid.instance.getSelectedRowsData().map((d) => oc(d)._trip._tripId());
    const selectedPairs: any[] = this.grid.instance.getSelectedRowsData().map(s => [s.id, oc(s)._trip._tripId()]);

    // console.log(this.grid.instance.getDataSource().sort());

    if (selectedPairs.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    notify('Meals Batch Requested');

    const notificationOptions: NotificationOptions = {
      body: 'Meals Batch Generation Done!',
      requireInteraction: true,
    };

    void Promise.all(
      selectedPairs.map(([sId]) =>
        this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'PENDING' } }]).toPromise(),
      ),
    );

    this.pusher
      .rpc('BUILD_CLAIMS_BATCH', {
        // signatureIds: selectedIds,
        // tripIds: selectedTripIds,
        pairs: selectedPairs,
        serviceType: 'MEALS',
        useRunTask: true,
      })
      .pipe(
        switchMap(() =>
          Promise.all(
            selectedPairs.map(([sId]) =>
              this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'IN BATCH' } }]).toPromise(),
            ),
          ),
        ),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe(res => console.log(res));
  }

  grid_toolbar_buildCtsReport_onClick(e: { itemData }) {
    const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();

    if (selectedIds.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    notify('Build Requested');

    const notificationOptions: NotificationOptions = {
      body: 'CTS Order Batch Generation Done!',
      requireInteraction: true,
    };

    void Promise.all(
      selectedIds.map(sId => this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'PENDING' } }]).toPromise()),
    );

    this.pusher
      .rpc('BUILD_CTS_ORDER_BATCH', {
        signatureIds: selectedIds,
        byFacility: e.itemData === 'by Facility',
        useRunTask: true,
      })
      .pipe(
        switchMap(() =>
          Promise.all(
            selectedIds.map(sId =>
              this.storeUpdate$([{ key: sId, values: { _currBatchStatus: 'IN BATCH' } }]).toPromise(),
            ),
          ),
        ),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  grid_toolbar_buildMtmAuthsToAdd_onClick(e: { itemData }) {
    const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();

    if (selectedIds.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    notify('Build Requested');

    const notificationOptions: NotificationOptions = {
      body: 'MTM Auths to Add Generation Done!',
      requireInteraction: true,
    };

    this.pusher
      .rpc('BUILD_MTM_AUTHS_TO_ADD', {
        signatureIds: selectedIds,
        byFacility: e.itemData === 'by Facility',
        useRunTask: true,
      })
      .pipe(
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe();
  }

  grid_toolbar_buildMealsReq_onClick() {
    const selectedIds: any[] = this.grid.instance.getSelectedRowKeys();

    if (selectedIds.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    notify('Build Requested');

    const notificationOptions: NotificationOptions = {
      body: 'Meals Trips Request Generation Done!',
      requireInteraction: true,
    };

    this.pusher
      .rpc('BUILD_MEALS_TRIPS_REQ', {
        signatureIds: selectedIds,
        useRunTask: true,
      })
      .pipe(
        tap(({ urls }) => (urls || []).forEach(url => window.open(url))),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe(res => console.log(res));
  }

  grid_toolbar_buildSchoolReport_onClick() {
    const selectedPairs: any[] = this.grid.instance.getSelectedRowsData().map(s => [s.id, oc(s)._trip._tripId()]);

    if (selectedPairs.length === 0) {
      notify('No trips selected', 'error', 5000);
      return;
    }

    notify('Report Requested');

    const notificationOptions: NotificationOptions = {
      body: 'Report Generation Done!',
      requireInteraction: true,
    };

    this.pusher
      .rpc('BUILD_SCHOOL_REPORT_RPC', {
        pairs: selectedPairs,
        useRunTask: true,
      })
      .pipe(
        tap((uris: string[]) => (uris || []).forEach(uri => window.open(uri))),
        //
        tap(() => this.notification.generateNotification({ title: 'Done!', opts: notificationOptions })),
        catchError(err => of(notify(err.message, 'error', 5000))),
        takeUntil(this.$onDestroy$),
      )
      .subscribe(console.log);
  }

  showPopover1(cellInfo: DxCellEvent<SVObject>) {
    this.currentPopoverTemplate = 'mealImg';
    this.popoverData = cellInfo.value;
    this.popoverTargetSelector = cellInfo.cellElement;
    this.isPopoverVisible = true;
  }

  showPopover2(cellInfo: DxCellEvent<SVObject>) {
    this.currentPopoverTemplate = 'addrMismatch';
    this.popoverData = cellInfo.data;
    this.popoverTargetSelector = cellInfo.cellElement;
    this.isPopoverVisible = true;
  }

  showTooltip3(cellInfo: DxCellEvent<SVObject>) {
    this.currentTooltipTemplate = 'trip';
    this.tooltipData = cellInfo.data;
    this.tooltipTargetSelector = cellInfo.cellElement;
    this.isTooltipVisible = true;
  }
}
